import React from "react";
import { GridColumn } from "emotion-flex-grid";
import { MenuContainer, SortItem } from "components/ProfilePage/styled";
import Pagination from "components/Pagination";
import {
  CardBody,
  CardImage,
  CardTime,
  CardTitle,
  Column,
  Card,
  PaymentBackground,
  CardActionIcons,
  CardAction,
  ViewsNumber,
} from "styles/MainCards.styled";
import CardIcon from "components/CardIcon";
import { saveCollectionAct } from "store/recipesReducer";
import { Spinner } from "styles/App.styled";
import { Icon } from "components/SvgIcons";
import Link from "next/link";
import { NoImage } from "styles/Preview.styled";
import { Item } from "shared/Slider/styled";
import { EmptyInfo } from "../styled";
import FiltersMenu from "../../../shared/FiltersMenu/FiltersMenu";
import AddItemCard from "components/AddItemCard";
import { cardsToShowAddCard } from "../../../store/recipesReducer/recipesConstants";
import { useSelector } from "react-redux";
import Sort from "../../Sort";
import cloudfront from "helpers/cloudfront";
import { CollectionsCardsWrap } from "../Products/styled";
import { getImageName } from "../../../helpers";
import { getOwner, getUser } from "store/userReducer/userSelectors";
import { useRouter } from "next/router";

const Collections = ({
  collections,
  isLoading,
  requestPage,
  filter,
  isFilterShow,
  isAddShow,
  isSortingShow,
  sortingSettings,
  isUsers,
  isManager,
}) => {
  const router = useRouter();
  const { results, count } = collections;
  const isEmpty = results.length === 0;
  const addingCollectionCard = !isLoading && isAddShow && results.length < cardsToShowAddCard;
  const currentUser = useSelector(getUser);
  const currentOwner = useSelector(getOwner);
  const userId = currentUser.id || currentOwner.id;

  return (
    <>
      {(isFilterShow || isSortingShow) && (
        <MenuContainer>
          {isFilterShow && <FiltersMenu {...filter} />}
          {isSortingShow && (
            <SortItem>
              <Sort {...sortingSettings} />
            </SortItem>
          )}
        </MenuContainer>
      )}
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          {isEmpty && !isAddShow ? (
            <GridColumn width={[12]} py={"xl"} px={"m"}>
              {!isUsers ? "Empty" : <EmptyInfo>This Creator doesn't have any collections yet.</EmptyInfo>}
            </GridColumn>
          ) : (
            <CollectionsCardsWrap>
              {results.map((item) => {
                const { views_count } = item;
                const viewsMessage = !views_count
                  ? "No views yet"
                  : views_count == 1
                  ? "1 view"
                  : `${views_count} views`;
                return (
                  <Column key={item.id}>
                    <Card>
                      <CardImage>
                        <Link href="/collection/[id]" as={`/collection/${item.id}`} passHref>
                          <a>
                            {item.main_image ? (
                              <img
                                className="cloudfront"
                                src={cloudfront({ href: item.main_image, size: "medium" })}
                                alt={getImageName(item.main_image)}
                              />
                            ) : (
                              <NoImage />
                            )}
                          </a>
                        </Link>
                        <PaymentBackground>
                          {item.purchased ? <Icon icon="newpurchase" /> : item.paid ? `$${item.price}` : "Free"}
                        </PaymentBackground>
                        <CardAction>
                          <CardActionIcons>
                            <CardIcon
                              id={item.id}
                              type="collections"
                              icon={item.saved ? "savedslide" : "saveslide"}
                              action={"save"}
                              setSaved={saveCollectionAct}
                            />
                          </CardActionIcons>
                          <CardTime>{item.recipes_count} recipes</CardTime>
                        </CardAction>
                      </CardImage>
                      <CardBody>
                        <CardTitle>{item.title}</CardTitle>
                        {userId != item.collection_creator.id && (
                          <Item>
                            <Link href="/users/[id]" as={`/users/${item.collection_creator.id}`} passHref>
                              <a>
                                {item.collection_creator.show_business_name ? (
                                  item.collection_creator.business_name
                                ) : (
                                  <>
                                    {item.collection_creator.first_name} {item.collection_creator.last_name}
                                  </>
                                )}
                              </a>
                            </Link>
                          </Item>
                        )}
                        {isManager && (
                          <ViewsNumber>
                            <Icon icon="views" />
                            {viewsMessage}
                          </ViewsNumber>
                        )}
                      </CardBody>
                    </Card>
                  </Column>
                );
              })}
              {addingCollectionCard && (
                <Column className="add-collection-button">
                  <AddItemCard itemType="collection" title="Create Collection" />
                </Column>
              )}
            </CollectionsCardsWrap>
          )}

          <Pagination stepClick={requestPage} countOfElements={count} destination={router.pathname} />
        </>
      )}
    </>
  );
};

export default Collections;
